import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { LetDirective, PushPipe } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { OnmatComponentActivitiesModule } from '@tekman/onmat/component/activities';
import { OnmatComponentModule } from '@tekman/onmat/component/onmat';
import { OnmatStoreGroupModule } from '@tekman/onmat/store/group';
import { OnmatUtilsModule } from '@tekman/onmat/utils';
import { SharedComponentGenericModule } from '@tekman/shared/component/generic';
import { SharedComponentModule } from '@tekman/shared/component/shared';
import { SharedUtilsModule, svgIcons } from '@tekman/shared/utils';
import { GroupSelectorComponent } from './component/selectors/group-selector/group-selector.component';
import { LanguageSelectorComponent } from './component/selectors/language-selector/language-selector.component';
import { SelectorService } from './component/selectors/services/selector.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    OverlayModule,
    SvgIconsModule.forChild(svgIcons),
    HttpClientModule,
    OnmatUtilsModule,
    SharedUtilsModule,
    OverlayModule,
    PortalModule,
    OnmatComponentModule,
    TranslateModule,
    OnmatStoreGroupModule,
    MatSelectModule,
    OnmatComponentActivitiesModule,
    SharedComponentModule,
    SharedComponentGenericModule,
    ReactiveFormsModule,
    LetDirective,
    PushPipe,
  ],
  declarations: [GroupSelectorComponent, LanguageSelectorComponent],
  exports: [GroupSelectorComponent, LanguageSelectorComponent],
  providers: [SelectorService],
})
export class OnmatComponentHocModule {}
